<script lang="ts">
	//Hooks
	import { createEventDispatcher, onMount } from 'svelte';
	//Formating
	import { format } from '../../services/i18n';
	//Map Components
	import Map from './Mapbox/MapBox.svelte';
	import MapMarker from './Mapbox/MapMarker.svelte';
	import GeolocationButton from './Mapbox/GeolocationButton.svelte';
	import ZoomButtons from './Mapbox/ZoomButtons.svelte';
	//Design system components
	import { Button, Modal, Text, Icon } from '@Shelly/shelly-design-system';
	import { mobile } from 'src/services/mobile-rework';
	import Autocomplete from './Mapbox/Autocomplete.svelte';

	export let lat: number,
		lng: number,
		showModal = false;

	let selectedMarkerPos: { lat: number; lng: number },
		mapCanvas: Map,
		onLocation = false;

	const dispatch = createEventDispatcher(),
		onDragEnd = (e: CustomEvent) => {
			onLocation = false;
			selectedMarkerPos = e.detail;
		},
		saveLocation = () => {
			showModal = false;
			dispatch('change', selectedMarkerPos);
		},
		onChangeGeoLocation = (e: CustomEvent) => {
			mapCanvas.fitMapToMarkers(
				[
					e.detail,
					selectedMarkerPos
						? { lat: selectedMarkerPos.lat, lon: selectedMarkerPos.lng }
						: { lat, lon: lng },
				],
				100,
			);
		},
		closeModal = (e: CustomEvent) => {
			if (showModal) {
				e.preventDefault();
				showModal = false;
			}
		};

	onMount(() => {
		if (mobile.isMobile) {
			mobile.addEventListener('back_button', closeModal);
			return () => mobile.removeEventListener('back_button', closeModal);
		}
	});

	let unique = {};
	const changeMarkerPosition = (newLat: number, newLng: number) => {
		if (newLat !== lat || newLng !== lng) unique = {};
	};

	const onClickOnMap = (e) => {
		changeMarkerPosition(e.detail.lat, e.detail.lon);
		lat = e.detail.lat;
		lng = e.detail.lon;
		selectedMarkerPos = { lat, lng };
	};

	const onSelect = async (e: any) => {
		changeMarkerPosition(e.detail.lat, e.detail.lon);
		lat = e.detail.lat;
		lng = e.detail.lon;
		mapCanvas.goToMap(lat, lng);
		selectedMarkerPos = { lat, lng };
	};
</script>

<Modal
	title={$format('select_map_location', { default: 'Select from map' })}
	bind:showModal
	on:close={() => (showModal = false)}
>
	<svelte:fragment slot="content">
		<Text class="mb-s"
			>{$format('drag_drop_to_set_new_position', {
				default: 'Drag and drop a marker to set up the new location',
			})}</Text
		>
		<Map center={[lng, lat]} zoom={16} bind:this={mapCanvas} on:click={onClickOnMap}>
			<Autocomplete on:select={onSelect} />
			{#key unique}
				<MapMarker {lat} {lng} draggable={true} on:dragEnd={onDragEnd}>
					<Icon
						icon="fa fa-times"
						class="text-danger"
						size="s"
						style={'position:absolute;bottom:-5px;left:0;right:0;margin:auto;'}
					/>
					<Icon
						class="text-primary"
						icon="fa fa-map-marker"
						size="l"
						style={'position:relative;'}
					/>
					<Icon
						icon="fas fa-microchip"
						class="text-white"
						size="s"
						style={'position:absolute;top:8px;left:12px;filter:drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.5));'}
					/>
				</MapMarker>
			{/key}
			<ZoomButtons />
			<GeolocationButton flyToMap={false} bind:onLocation on:change={onChangeGeoLocation} />
		</Map>
	</svelte:fragment>
	<svelte:fragment slot="footer">
		<div class="d-flex justify-content-center">
			<Button
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
				disabled={!selectedMarkerPos}
				responsiveSize={{
					sm: 'm',
				}}
				on:click={saveLocation}
			>
				{$format('label_select', { default: 'Select' })}
			</Button>
		</div>
	</svelte:fragment>
</Modal>
